const sessionStorageClient = window.localStorage;

export default sessionStorageClient;
